import { render, staticRenderFns } from "./UATPIcon.vue?vue&type=template&id=12b9a074&"
import script from "./UATPIcon.vue?vue&type=script&lang=js&"
export * from "./UATPIcon.vue?vue&type=script&lang=js&"
import style0 from "./UATPIcon.vue?vue&type=style&index=0&id=12b9a074&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports